import { useMutation } from "react-query";
import { configSrore } from "../configSrore";
import { ERequest } from "../interface";
import Fetch from "../utils/fetch";

export default function useDeleteFile() {
  return useMutation(
    async (values: {
      page: number,
      resourceId:number,
      userGroupHash:string,
      fileHash: string
      callBack?: () => void }) => {
      const {
        resourceId,
        fileHash,
      } = values;

      await Fetch({
        url: `${configSrore.clasorUrl}files/resource/${resourceId}/fileHash/${fileHash}`,
        method: ERequest.DELETE,
      });
    },
    {
      onSuccess: (_result, values) => {
        const { callBack } = values;
        callBack?.();
      },
    },
  );
}
